import owd from 'owd/owd';

export default class Products extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
        this.on('click', () => {
            if (Modernizr.touch && !this.$element.hasClass('open') && !window.matchMedia('(max-width: 767px)').matches) {
                this.$element.addClass('open');
            }
        })
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('products', {
    component: Products
});
